<template>
  <div class="bg-white px-6">
    <div v-if="!privacy">
      <div class="flex items-center justify-between">
        <div class="text-xl font-semibold py-6">Terms of service</div>
        <div @click="close">
          <close-icon :width="'w-4'" :height="'h-4'"></close-icon>
        </div>
      </div>
      <div class="max-h-full overflow-y-scroll">
        <div class="max-h-90-screen">
          <div class="text-left">
            <div class="font-bold uppercase pb-2"><span class="pr-3">1.</span> Agreement to terms</div>
            <div class="text-sm text-justify">
              These Terms of Use constitute a legally binding agreement made between you, whether personally or on
              behalf of an entity (“you” or the “End User”) and Northwing Logistics Limited (“we”, “us”, or “our”),
              concerning your access to and use of the northwinglogistics.com website as well as any other media form,
              media channel, mobile website, or mobile application related, linked, or otherwise connected thereto
              (collectively, the “Site”). You agree that by using this Site, you have read, understood and, agree to be
              bound by all these Terms and Conditions. IF YOU DO NOT AGREE TO ALL THESE TERMS AND CONDITIONS, THEN YOU
              ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.
            </div>
            <div class="text-sm text-justify py-2">
              Supplemental terms and conditions or documents that may be posted on the Site from time to time are hereby
              expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes
              or modifications to these Terms of Use at any time and for any reason. We will alert you about any changes
              by updating the “Last updated” date of these Terms of Use, and you waive any right to receive specific
              notice of each such change. It is your responsibility to periodically review these Terms and Conditions to
              stay informed of updates. You will be subject to, and will be deemed to have been made aware of and to
              have accepted the changes in any revised Terms and Conditions by your continued use of the Site after the
              date such revised Terms and Conditions are posted.
            </div>
            <div class="text-sm text-justify py-2">
              The information provided on the Site is not intended for distribution to or use by any person or entity in
              any jurisdiction or country where such distribution or use would be contrary to law or regulation or which
              would subject us to any registration requirement within such jurisdiction or country. Accordingly, those
              persons who choose to access the Site from other locations do so on their own initiative and are solely
              responsible for compliance with local laws, if and to the extent local laws are applicable.
            </div>
            <div class="font-bold uppercase pt-4 pb-2"><span class="pr-3">2.</span> Definition of terms</div>
            <div class="text-sm text-justify">
              “We”, “us”, “our” and “Northwing” means Northwing Logistics Limited, subsidiaries, affiliates, employees,
              representatives and agents of Northwing Logistics Limited;
            </div>
            <div class="text-sm text-justify py-2">
              “You” and “your” means the sender, consignor or consignee, receiver and owner of the contents of the
              shipment or any other person having a legal interest in those contents;
            </div>
            <div class="text-sm text-justify py-2">
              “Carriage” means and includes the whole of the operations and services undertaken by us in connection with
              the shipment;
            </div>
            <div class="text-sm text-justify py-2">“Nigeria” means the Federal Republic of Nigeria</div>
            <div class="text-sm text-justify py-2">
              “Shipment” and “Consignment” means any goods or documents of whatever nature (whether in bulk or in one or
              more packages which we have accepted for carriage from one destination to another whether under our
              waybill or not)
            </div>
            <div class="text-sm text-justify py-2">
              “Site” means northwinglogistics.com (insert correct name of the website) website as well as any other
              media form, media channel, mobile website, or mobile application related, linked, or otherwise connected
              thereto
            </div>
            <div class="text-sm text-justify py-2">
              “Terms of Use” or “Terms of Conditions” can be used interchangeably and both refer to this agreement
            </div>
            <div class="text-sm text-justify py-2">
              The information provided on the Site is not intended for distribution to or use by any person or entity in
              any jurisdiction or country where such distribution or use would be contrary to law or regulation or which
              would subject us to any registration requirement within such jurisdiction or country. Accordingly, those
              persons who choose to access the Site from other locations do so on their own initiative and are solely
              responsible for compliance with local laws, if and to the extent local laws are applicable.
            </div>
            <div class="font-bold uppercase pt-4 pb-2"><span class="pr-3">3.</span> Terms of Consignment contract</div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.1</span> Scope of contract</div>
            <div class="text-sm text-justify">
              By concluding any type of consignment contract with us and giving us your consignment, you accept our
              terms and conditions set out on our website-www.northwinglogistics.com and on our waybill, on behalf of
              yourself and/or anyone else who has an interest in the shipment irrespective of whether you have signed
              the front of our waybill or not. No agent, servant or representative of Northwing has the authority to
              modify, alter or waive any provision of this contract. When you give us the consignment with oral or
              written instructions which conflict with our terms and conditions, we shall not be bound by such
              instructions. You acknowledge and accept that shipments will be consolidated with those of other shippers
              for transport and that we may not monitor the inbound and outbound movement of individual shipments at all
              handling centers and to hold us harmless against any loss/damage that may result from such consolidation.
              Northwing is not a common carrier and reserves the right in its absolute discretion to refuse carriage to
              any package/cargo tendered to it for transportation.
            </div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.2</span>Documentation of consignments</div>
            <div class="text-sm text-justify py-2">
              You agree that you shall declare the actual contents of your consignment and be bound by the description
              as written on our waybill. The names, addresses and telephone numbers of the consignor and consignee shall
              be provided by you and you agree that we shall not be liable for any loss or delay in delivery occasioned
              by your failure to provide these details. You undertake that it is your responsibility to declare the
              value of your shipment, and agree that we are not bound to request such information from you. That where
              you fail to make such declaration to us and which must be written on the waybill, you shall hold us
              harmless and free from any liability arising from any loss or damage to your shipment howsoever caused,
              and that the said shipment is shipped at owner’s risk.
            </div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.3</span>Packaging of consignments</div>
            <div class="text-sm text-justify py-2">
              You shall be solely responsible for the packaging of your consignment in such a way that it can withstand
              normal handling. Consignments of fragile nature must be packed in crates with foam, foam pellets and other
              such protective casing with a “fragile” tag attached thereto. Any loss or damage to your consignment
              arising out of your failure to pack it in the aforesaid manner is strictly at your cost.
            </div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.4</span>Prohibited/dangerous goods</div>
            <div class="text-sm text-justify py-2">
              Northwing does not carry illegal or prohibited goods, which are goods prohibited by law, rule or
              regulation of any state/country in which the shipment travels. We do not carry animals, currency, bearer
              forms, negotiable instruments, precious metals and stones, firearms/parts thereof and ammunitions, human
              remains, pornography and illegal narcotics and drugs. You agree that your consignment is acceptable for
              carriage and undertake to indemnify Northwing for any customs duties, taxes, penalties and other expenses
              or charges which we incur as a result of the actions of customs or other governmental authorities for your
              failure to provide proper documentations and/or obtain the required license or permit. You acknowledge
              that in the event that you make a fraudulent or untrue statement about the shipment or any of its
              contents, you risk a civil claim and/or criminal prosecution the penalties for which include forfeiture
              and sale of your shipment. You agree to indemnify us and hold us harmless from any claims that may be
              brought against us arising from the carriage of your consignment and any costs that we may incur regarding
              this. Perishable and temperature sensitive goods, which include but not limited to fruits, vegetables,
              flowers, meat, poultry, all types of bakery and other related goods may be accepted for shipment, provided
              it is entirely at the owner’s risk.
            </div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.5</span>Inspection</div>
            <div class="text-sm text-justify py-2">
              Northwing reserves the right, but is not obliged to open and inspect any shipment tendered to it for
              transportation at any time, without prior notice to you.
            </div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.6</span>Charges and payment</div>
            <div class="text-sm text-justify py-2">
              <div class="pr-3 font-semibold">3.6.1</div>
              Northwing’s shipment charges are calculated according to the higher or actual or volumetric weight and any
              shipment may be re-measured and re-weighed by Northwing to confirm this calculation. Our carriage charges
              are calculated in accordance with the rates applicable as set out in our current rate card. You must
              insist that official receipts are issued for each payment made. You agree to pay or reimburse us for all
              shipment charges, storage charges (demurrage), duties and taxes owed for services provided by Northwing or
              incurred by Northwing on your behalf and all claims, damages, fines and expenses incurred if the shipment
              is deemed unacceptable for transport as described in Clause 3.4 .
            </div>
            <div class="text-sm text-justify py-2">
              <div class="pr-3 font-semibold">3.6.2</div>
              Cancellation of the contract when a waybill has been issued attracts a service charge of 25% if the rider
              has not embarked on the delivery journey. However, where the driver has embarked on the delivery journey
              and the you call to cancel the delivery, you will be charged 60% of the amount for carriage. Northwing
              reserves the right to, within our discretion, apply the 40% to your next order or reimburse the 40% to an
              account you have provided.
            </div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.7</span>Northwing’s liability</div>
            <div class="text-sm text-justify py-2">
              Northwing contracts with consignor on the basis that our liability is strictly limited to direct loss only
              and to the limits in this Clause 3.7. If we have a liability to you for whatever reason including but not
              limited to breach of contract, negligence, willful act or default, it is at all times limited to the
              actual amount of any loss or damage to the consignment and for the purpose of this contract we mean the
              actual value of the shipment. The actual cost of the shipment shall be the cost of repairing or replacing
              the consignment whichever is lower, within every case an upper limit that does not exceed N150 per
              kilogram with a maximum of N7,500 per shipment. Essentially, our liability is capped at N7,500 per
              shipment and will be calculated at N150 per kilogram.
            </div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.8</span>Exclusions</div>
            <div class="text-sm text-justify py-2">
              <div class="pr-3 font-semibold">3.8.1</div>
              Northwing shall not be liable for any loss or damage including but not limited to lost profit, loss of
              income, loss of interest, loss of future business, loss of market, loss of reputation, loss of commercial
              personal value, incidental, special or consequential damages or loss howsoever arising including but not
              limited to the loss, damage, delay, misdelivery or non-delivery of your shipment (except such loss,
              damage, delay, misdelivery or non-delivery is wilfully or negligently caused by us), whether the risk of
              such loss or damage was brought to our attention before or after acceptance of the shipment since special
              risks can be insured by the consignor.
            </div>
            <div class="text-sm text-justify py-2">
              <div class="pr-3 font-semibold">3.8.2</div>
              We shall make every reasonable effort to deliver the shipment according to our regular delivery schedules,
              but these are not guaranteed and do not form part of the contract.
            </div>
            <div class="text-sm text-justify py-2">
              <div class="pr-3 font-semibold">3.8.3</div>
              We are not liable if your shipment or any part of it is lost, damaged, delayed or misdelivered or not
              delivered or if we do not fulfil any obligations towards you as a result of:
              <div class="text-sm text-justify pb-2">
                <div class="flex">
                  <div class="mr-3 py-px text-xs">o</div>
                  <div>
                    Circumstances beyond our control such as (but not limited to): Acts of God including earthquakes,
                    storms, floods, fire, disease, cyclones, fog, pandemics or epidemics; war, accidents, acts of public
                    enemies, strikes, embargoes, riots, local disputes or civil commotion; national or local disruptions
                    in road transportation networks and mechanical problems to modes of transport or machinery or bad
                    roads.; latent defects or inherent vice in the contents of the shipment; criminal acts of third
                    parties such as theft and arson.
                  </div>
                </div>
                <div class="flex">
                  <div class="mr-3 py-px text-xs">o</div>
                  <div>
                    Your acts or omissions or those of third parties such as: <br />
                    A breach by you (or any other party claiming interest in the shipment) or your obligations under
                    these terms and conditions and in particular the warranties set out herein; An act or omission of
                    any authority or agent of government.
                  </div>
                </div>
                <div class="flex">
                  <div class="mr-3 py-px text-xs">o</div>
                  <div>
                    The contents of the shipment consisting of any article that is a prohibited item even though we may
                    have accepted the consignment in error.
                  </div>
                </div>
              </div>
            </div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.9</span>Claims Procedure</div>
            <div class="text-sm text-justify py-2">
              Claims are limited to one claim per shipment settlement of which will be full and final settlement for all
              loss or damage in connection therewith. You undertake that you shall not permit any other person who has
              interest in the shipment to bring a claim or action against us arising from the carriage even though we
              may have been negligent or in default and if a claim or action is made, you will indemnify us against the
              consequences of the claim and the costs and expenses we incur in defending it. All claims must be
              submitted in writing to Northwing within thirty (30) days from the date we accepted the consignment for
              dispatch, failing which we shall have no liability whatsoever. We are not obliged to act on any claim
              until our carriage charges have been paid nor are you entitled to deduct the amount of your claim from our
              carriage charges. The shipment will be deemed to have been delivered in good condition, once you accept
              the shipment and sign off on the appropriate portion of the waybill, unless the receiver has noted any
              damage on the delivery record when he/she accepted the shipment.
            </div>
            <div class="font-bold capitalize pt-2 pb-2"><span class="pr-3">3.10</span>Indemnity</div>
            <div class="text-sm text-justify py-2">
              You will indemnify us (and our officers, directors, agents, subsidiaries, joint venturers and employees)
              against any claim or demand, including legal fees and costs, made against us by any third party due to or
              arising out of your breach of this Terms of Use, or your infringement of any law or the rights of a third
              party in the course of using the Site and Northwing Services.
            </div>
            <div class="font-bold capitalize pt-2 pb-2">
              <span class="pr-3">3.11</span>Consignor’s warranties and indemnity
            </div>
            <div class="text-sm text-justify py-2">
              You shall indemnify and hold Northwing harmless for any loss or damage arising out of your failure to
              comply with any applicable laws or regulations and for your breach of the following warranties and
              representations:
            </div>
            <div class="text-sm text-justify pb-2">
              <div class="flex">
                <div class="mr-3 py-px text-xs">o</div>
                <div>All information provided by the consignor or its representative is complete and accurate;</div>
              </div>
              <div class="flex">
                <div class="mr-3 py-px text-xs">o</div>
                <div>
                  The shipment is properly packed, marked and addressed to ensure safe transportations with ordinary
                  care in handling;
                </div>
              </div>
              <div class="flex">
                <div class="mr-3 py-px text-xs">o</div>
                <div>
                  Shipment of a fragile nature are properly packed and rated with foam, pellets or other insulating
                  material and clearly marked as fragile with the label attached visibly thereto.
                </div>
              </div>
            </div>
            <div class="font-bold uppercase pt-4 pb-2"><span class="pr-3">4.</span>Intellectual property rights</div>
            <div class="text-sm text-justify pb-2">
              Unless otherwise indicated, the Site is our proprietary property and all source code, databases,
              functionality, software, website designs, audio, video, text, photographs, and graphics on the Site
              (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the “Marks”)
              are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and
              various other intellectual property rights and competition laws of the Federal Republic of Nigeria,
              international treaties, and agreements and conventions Nigeria is signatory to. The Content and the Marks
              are provided on the Site “AS IS” for your information and personal use only. Except as expressly provided
              in these Terms of Use, no part of the Site and no Content or Marks may be copied, reproduced, aggregated,
              republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold,
              licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written
              permission.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">5.</span>Limitation of liability</div>
            <div class="text-sm text-justify pb-2">
              To the extent permitted by law, in no event shall Northwing, its affiliates or licensors or any third
              parties mentioned on the Site be liable for any incidental, indirect, exemplary, punitive and
              consequential damages, lost profits, or damages resulting from lost data or business interruption
              resulting from the use of or inability to use the Site, services, content or information whether based on
              warranty, contract, tort, delict, or any other legal theory, and whether or not Northwing is advised of
              the possibility of such damages. Without limiting the foregoing, to the extent permitted by applicable
              law, you agree that in any event, Northwing’s total liability for any damages (direct or otherwise) or
              loss regardless of the form of action or claim, whether in contract, tort or otherwise, shall be limited
              to the amount paid, if any, by you to us. To the extent permitted by law, the remedies stated for you in
              these terms and conditions are exclusive and are limited to those expressly provided for in these terms
              and conditions.
            </div>
            <div class="font-bold uppercase pt-4 py-2 inline-block"><span class="pr-3">6.</span>Privacy Policy</div>
            <div @click="privacy = true" class="underline text-sm font-semibold inline-block pl-4 text-green-700">
              view privacy policy
            </div>
            <div class="text-sm text-justify pb-2">
              By using the Site, you agree to be bound by our Privacy Policy posted on our Site which is incorporated
              into this Terms and Conditions. Our Privacy Policy provides information on how the Site collects and uses
              your personal data and for which purposes. The Site is hosted in Nigeria. If you access the Site from any
              other region of the world with laws or other requirements governing personal data collection, use, or
              disclosure that differ from applicable laws in Nigeria, then through your continued use of the Site, you
              are transferring your data to Nigeria, and you agree to have your data transferred to and processed in
              Nigeria.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">7.</span>Copy Right</div>
            <div class="text-sm text-justify pb-2">
              Copyright and other relevant intellectual property rights exist on all text relating to Northwing services
              and the full content of this website.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">8.</span>Viruses</div>
            <div class="text-sm text-justify pb-2">
              Northwing makes all reasonable attempts to exclude viruses from the Site, but it cannot ensure this
              exclusion and no liability is accepted for viruses. Please take all appropriate safeguards before
              downloading information from the Site.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">9.</span>Governing law</div>
            <div class="text-sm text-justify pb-2">
              These Terms and Conditions are governed by the laws of Nigeria. By accessing the Site and using Northing’s
              services, you consent to these terms and conditions and to the exclusive jurisdiction of the Nigerian
              courts in all disputes arising out of such access. If any of these terms are deemed invalid or
              unenforceable for any reason (including, but not limited to the exclusions and limitations set out above),
              then the invalid or unenforceable provision will be severed from these terms and the remaining terms will
              continue to apply. Failure of Northing to enforce any of the provisions set out in these Terms and
              Conditions, shall not be construed as waiver of such provisions and shall not affect the validity of these
              Terms and Conditions or any part thereof, or the right thereafter to enforce each and every provision.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">10.</span>Amendments</div>
            <div class="text-sm text-justify pb-2">
              These Terms and Conditions may be amended, modified, varied or supplemented from time to time to enhance
              user experience and delivery of services offered by Northwing on the Site. Where an update is to be made,
              a notice will be posted on the Site at least 20 days before the update is made informing users that the
              Terms and Conditions will be updated. The format of this notice shall be determined solely at the
              discretion of Northwing.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">11.</span>Corrections</div>
            <div class="text-sm text-justify pb-2">
              The Site may contain inadvertent inaccuracies, typographical errors or omissions. These will be corrected
              at Northwing’s discretion, as they are found. The information on the Site is updated regularly, but
              inaccuracies may remain or occur where changes occur between updates.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">12.</span>Disclaimer of warranties</div>
            <div class="text-sm text-justify pb-2">
              Northwing, to the fullest extent permitted by law, disclaims all warranties, whether express, implied,
              statutory or otherwise, including but not limited to the implied warranties of merchantability,
              non-infringement of third parties’ rights and fitness for a particular purpose. Northwing, its affiliates
              and licensors make no representations or warranties about the accuracy, completeness, security or
              timeliness of the services, content or information provided on or through the Northwing website or
              systems. No information obtained via the Northwing systems or website shall create any warranty not
              expressly stated by Northwing in these terms and conditions. If you are dealing as a consumer, these
              provisions do not affect your statutory rights that cannot be waived, if any. You agree and acknowledge
              that the limitations and exclusions of liability and warranty provided in these terms and conditions are
              fair and reasonable.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">13.</span>Disclosure of information</div>
            <div class="text-sm text-justify pb-2">
              All information provided to Northwing by visitors to the Site is considered to be confidential and will
              not be disclosed by Northwing to any third party except as required or the provision of the services.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">14.</span>Comments</div>
            <div class="text-sm text-justify pb-2">
              Northwing wants your feedback and appreciates your ideas and suggestions but may be unable to answer every
              comment individually. Northwing will be free to use and act on any information you submit.
            </div>
            <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">15.</span>Interactive features</div>
            <div class="text-sm text-justify pb-6">
              For your convenience, Northwing may provide interactive features on this site, such as access to tracking
              and user comments. You are authorized to use these features solely for the purposes specified and for no
              other purposes.
            </div>
          </div>
        </div>
      </div>
    </div>
    <privacy-policy v-if="privacy" v-on:privacy-policy="closePolicy"></privacy-policy>
  </div>
</template>

<script>
import CloseIcon from '../components/icons/CloseIcon.vue'
import PrivacyPolicy from './PrivacyPolicy.vue'
export default {
  components: { CloseIcon, PrivacyPolicy },
  data() {
    return {
      privacy: false
    }
  },
  methods: {
    close() {
      this.$emit('terms-condition', false)
    },
    closePolicy(val) {
      this.privacy = val
    }
  }
}
</script>

<style></style>
